var render = function render(){var _vm=this,_c=_vm._self._c;return _c('observer',{attrs:{"root-margin":_vm.rootMargin,"threshold":_vm.threshold},on:{"on-change":_vm.onChange}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }